import PropTypes from 'prop-types'
import React, { createRef } from 'react'
import { connect } from 'react-redux'
import focusable from '../../components/Focusable/Focusable'
import FocusableButton from '../../components/FocusableButton/FocusableButton'
import tts from '../../../src/lib/TTS'
import StationPassportTitle from '../../components/StationPassportTitle/StationPassportTitle'
import {
  getActivationContent,
  getDeclineConfirmationContent,
  getMoreInformationContent,
} from './content'
import {
  platformStoreDelete,
  platformStoreSet,
} from '../../../../shared/helpers.js'
import { activatePassport } from '../../actions/userActions'
import PBSError from '../../../../shared/PBSError'
import ErrorModal from '../../components/ErrorModal/ErrorModal'
import { store } from '../../../src/store'
import googleAnalytics4 from '../../lib/googleAnalytics'
import { getUrlSearchParameter } from '../../../../shared/helpers'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'
import Spinner from '../../components/Spinner/Spinner.js'

class PassportActivationScreen extends React.Component {
  constructor(props) {
    super(props)
    this.activateAndStartWatchingButtonRef = createRef()
    this.moreInformationButtonRef = createRef()
    this.goBackToConfirmButtonRef = createRef()
    this.declineButtonRef = createRef()
    this.declineAnywayButtonRef = createRef()
    const stationTitle =
      props.router.location.state?.stationTitle ??
      this.getQueryParams('stationTitle')
    this.activationContent = getActivationContent(stationTitle, props.userEmail)
    this.declineConfirmationContent =
      getDeclineConfirmationContent(stationTitle)
    this.moreInformationContent = getMoreInformationContent(stationTitle)
    this.state = {
      displayedScreen: '',
      error: undefined,
      justMounted: true,
      justFocusedActivateAndStartWatchingBtn: false,
      justFocusedGoBackBtn: false,
      stationTitle,
      spinnerVisible: false,
    }
  }

  showScreen(screenName) {
    this.setState({ displayedScreen: screenName })
    switch (screenName) {
      case 'decline':
        googleAnalytics4.sendPageViewEvent('VPPA Confirm 2')
        this.setState({ justFocusedGoBackBtn: true })
        setTimeout(() => {
          this.goBackToConfirmButtonRef.current?.setFocus()
        }, 0)
        break
      case 'moreInformation':
        this.setState({ justFocusedActivateAndStartWatchingBtn: true })
        setTimeout(() => {
          this.activateAndStartWatchingButtonRef.current?.setFocus()
        }, 0)
        googleAnalytics4.sendPageViewEvent('VPPA Confirm 1')
        break
      case 'activation':
        this.setState({ justFocusedActivateAndStartWatchingBtn: true })
        setTimeout(() => {
          this.activateAndStartWatchingButtonRef.current?.setFocus()
        }, 0)
        googleAnalytics4.sendPageViewEvent('Activate & Start Watching')
        break
      default:
        break
    }
  }

  componentDidMount() {
    this.showScreen('activation')
  }

  getQueryParams = (key) => {
    return getUrlSearchParameter(this.props.router.location.search, key)
  }

  componentDidUpdate(prevProps) {
    const { userValidPassport } = this.props
    const { userValidPassport: prevUserValidPassport } = prevProps

    if (COMPILING_FOR_COMCASTX1) {
      platformStoreSet('activePassport', userValidPassport)
      this.updateEntitlementsFirebolt(userValidPassport)
    }

    if (prevUserValidPassport !== userValidPassport) {
      if (userValidPassport) {
        googleAnalytics4.sendCustomEvent(
          'passport_activation_success',
          null,
          'Passport Activation Screen'
        )
        platformStoreDelete('mvault_id')
        this.navigateBackToPreviousScreen()
      }
    }
  }

  navigateBackToPreviousScreen = () => {
    const navigatingFromDonation =
      this.props.router.location.state?.navigatingFromDonation ?? false
    const customDonation =
      this.props.router.location.state?.customDonationType ?? false

    if (navigatingFromDonation) {
      if (customDonation) {
        this.props.router.navigate(-3)
      } else {
        this.props.router.navigate(-2)
      }
    } else {
      this.props.router.navigate(-1)
    }
  }

  onKeyEvent(key) {
    tts.stop()
    switch (key) {
      case 'UP':
        return this.handleKeyUp()
      case 'DOWN':
        return this.handleKeyDown()
      case 'BACK':
        if (this.state.displayedScreen != 'activation') {
          this.handleGoBackToConfirmBtnClick()
        } else {
          this.navigateBackToPreviousScreen()
        }
        break
      default:
        return false
    }
  }

  handleKeyUp() {
    if (this.declineButtonRef.current?.isFocused()) {
      this.activateAndStartWatchingButtonRef.current?.setFocus()
    }
    if (this.activateAndStartWatchingButtonRef.current?.isFocused()) {
      this.moreInformationButtonRef.current?.setFocus()
    }
    if (this.declineAnywayButtonRef.current?.isFocused()) {
      this.goBackToConfirmButtonRef.current?.setFocus()
    }
    return true
  }

  handleKeyDown() {
    if (this.goBackToConfirmButtonRef.current?.isFocused()) {
      this.declineAnywayButtonRef.current?.setFocus()
    }
    if (this.moreInformationButtonRef.current?.isFocused()) {
      this.activateAndStartWatchingButtonRef.current?.setFocus()
    }
    if (this.activateAndStartWatchingButtonRef.current?.isFocused()) {
      this.declineButtonRef.current?.setFocus()
    }
    return true
  }

  updateEntitlementsFirebolt(userValidPassport) {
    import('@firebolt-js/sdk').then(async function (firebolt) {
      const Discovery = firebolt.Discovery
      const currentDate = new Date()
      const startTime = new Date(currentDate)
      startTime.setDate(currentDate.getDate() - 1)
      const endTime = new Date(startTime)
      endTime.setFullYear(
        startTime.getFullYear() + (userValidPassport ? 2 : 10)
      )
      const entitlementPath = userValidPassport
        ? 'pbs/entitlement/subscription'
        : 'pbs/entitlement/Basic'
      Discovery.entitlements([
        {
          entitlementId: entitlementPath,
          startTime: startTime,
          endTime: endTime,
        },
      ])
    })
  }

  handleActivateAndStartWatchingBtnClick = async () => {
    const { userValidPassport } = this.props
    if (this.state.displayedScreen == 'activation') {
      try {
        this.setState({ spinnerVisible: true })
        await activatePassport()
        this.setState({ spinnerVisible: false })
        if (COMPILING_FOR_COMCASTX1) {
          platformStoreSet('activePassport', userValidPassport)
          this.updateEntitlementsFirebolt(userValidPassport)
        }
      } catch (e) {
        this.setState({ spinnerVisible: false })
        if (e instanceof PBSError) {
          googleAnalytics4.sendCustomEvent(
            'passport_activation_failure',
            {
              error_code_id: e.errorStatus,
              error_code_title: e.errorCode,
              error_code_text: e.errorDetail,
            },
            'Passport Activation Screen'
          )

          const state = store.getState()
          PBSError.sendSentryError({
            errorString: 'MVault service error',
            errorTitle: 'PassportActivationScreen.js',
            extraParams: {
              errorCodeNumber: e.errorStatus,
              errorCodeText: e.name,
              errorMessage: e.message,
              userPid: state.user.pid,
              partnerID: state.device.distributor,
            },
          })
          const { errorMessage: error } = e.parse()
          const buttons = [
            {
              label: 'OK',
              name: 'goBackButton',
              onClick: () => {
                this.navigateBackToPreviousScreen()
              },
            },
          ]
          this.setState({ spinner: false })
          this.setState({
            error: { ...error, buttons },
          })
        }
      }
    } else {
      this.showScreen('activation')
    }
  }

  handleMoreInformationBtnClick = () => {
    this.showScreen('moreInformation')
  }

  handleGoBackToConfirmBtnClick = () => {
    this.showScreen('activation')
  }

  handleDeclineAnywayBtnClick = () => {
    const navigatingFromDonation =
      this.props.router.location.state?.navigatingFromDonation ?? false

    if (navigatingFromDonation) {
      this.props.router.navigate(-2)
    } else {
      this.props.router.navigate(-1)
    }
  }

  handleDeclineBtnClick = () => {
    this.showScreen('decline')
  }

  handleActivateAndStartWatchingBtnFocused = () => {
    tts.stop()
    let textToRead = ''
    if (this.state.justMounted) {
      textToRead += `${this.state.stationTitle} passport ..... `
      this.setState({ justMounted: false })
    }
    if (this.state.justFocusedActivateAndStartWatchingBtn) {
      textToRead += `${
        this.state.displayedScreen == 'activation'
          ? this.activationContent.tts
          : this.moreInformationContent.tts
      } ..... `
      this.setState({ justFocusedActivateAndStartWatchingBtn: false })
    }
    textToRead += `Focused on activate and start watching button`
    tts.addTextToRead(textToRead)
  }

  handleMoreInformationBtnFocused = () => {
    tts.stop()
    tts.addTextToRead('Focused on more information button')
  }

  handleGoBackToConfirmBtnFocused = () => {
    tts.stop()
    if (this.state.justFocusedGoBackBtn) {
      tts.addTextToRead(
        `${this.declineConfirmationContent.tts} ..... Focused on go back to confirm button`
      )
      this.setState({ justFocusedGoBackBtn: false })
    } else {
      tts.addTextToRead('Focused on go back to confirm button')
    }
  }

  handleDeclineAnywayBtnFocused = () => {
    tts.stop()
    tts.addTextToRead('Focused on decline anyway button')
  }

  handleDeclineBtnFocused = () => {
    tts.stop()
    tts.addTextToRead('Focused on decline button')
  }

  getCurrentScreenContent() {
    const { displayedScreen } = this.state
    let contentData
    switch (displayedScreen) {
      case 'decline':
        contentData = this.declineConfirmationContent
        break
      case 'moreInformation':
        contentData = this.moreInformationContent
        break
      case 'activation':
      default:
        contentData = this.activationContent
        break
    }
    return contentData
  }

  render() {
    const content = this.getCurrentScreenContent()
    const { displayedScreen, spinnerVisible } = this.state
    const isConfirmationScreen =
      displayedScreen == 'decline' || displayedScreen == 'moreInformation'
    const { error } = this.state
    return error ? (
      <ErrorModal
        title={error.errorTitle}
        description={error.errorText}
        error={error.e}
        buttons={error.buttons}
        componentType="errorModal"
        visible={true}
        hideStationLogo={true}
      />
    ) : (
      <div
        className={`passport-activation ${
          isConfirmationScreen ? 'passport-activation--confirmation' : ''
        }`}
      >
        <div className="passport-activation__spinner">
          {spinnerVisible && <Spinner visible={spinnerVisible} />}
        </div>
        <div className="passport-activation__header">
          <StationPassportTitle
            stationTitle={this.state.stationTitle}
            className="passport-activation__station-title"
          />
          {displayedScreen == 'activation' && (
            <FocusableButton
              parent={this}
              componentType="moreInformation"
              onClick={this.handleMoreInformationBtnClick}
              onFocused={this.handleMoreInformationBtnFocused}
              className="passport-activation__button passport-activation__button--rank3"
              ref={this.moreInformationButtonRef}
            >
              More Information
            </FocusableButton>
          )}
        </div>
        <div className="passport-activation__body">
          <div
            className={`passport-activation__content passport-activation__content--${
              isConfirmationScreen ? 'confirmation' : 'activation'
            }`}
          >
            <h1 className="passport-activation__content-title">
              {content.title}
            </h1>
            <p className={`passport-activation__content-description`}>
              {content.description}
            </p>
          </div>
          <figure
            className={`passport-activation__image-container ${
              isConfirmationScreen
                ? 'passport-activation__image-container--hidden'
                : ''
            }`}
          >
            <img
              className="passport-activation__image"
              src={this.activationContent.image}
            />
          </figure>
        </div>
        <div className="passport-activation--confirmation__controls">
          {(displayedScreen == 'activation' ||
            displayedScreen == 'moreInformation') && (
            <FocusableButton
              parent={this}
              componentType="activateAndStartWatching"
              onClick={this.handleActivateAndStartWatchingBtnClick}
              onFocused={this.handleActivateAndStartWatchingBtnFocused}
              className="passport-activation__button passport-activation__button--rank1"
              ref={this.activateAndStartWatchingButtonRef}
            >
              {displayedScreen == 'activation'
                ? 'Activate & Start Watching'
                : 'Go Back to Confirm'}
            </FocusableButton>
          )}
          {displayedScreen == 'decline' && (
            <FocusableButton
              parent={this}
              componentType="goBackToConfirm"
              onClick={this.handleGoBackToConfirmBtnClick}
              onFocused={this.handleGoBackToConfirmBtnFocused}
              className="passport-activation__button passport-activation__button--rank1"
              ref={this.goBackToConfirmButtonRef}
            >
              Go Back to Confirm
            </FocusableButton>
          )}
          {displayedScreen == 'moreInformation' && (
            <FocusableButton
              parent={this}
              componentType="decline"
              onClick={this.handleDeclineBtnClick}
              onFocused={this.handleDeclineBtnFocused}
              className="passport-activation__button passport-activation__button--rank2"
              ref={this.declineButtonRef}
            >
              Decline
            </FocusableButton>
          )}
          {displayedScreen == 'decline' && (
            <FocusableButton
              parent={this}
              componentType="declineAnyway"
              onClick={this.handleDeclineAnywayBtnClick}
              onFocused={this.handleDeclineAnywayBtnFocused}
              className="passport-activation__button passport-activation__button--rank2"
              ref={this.declineAnywayButtonRef}
            >
              Decline Anyway
            </FocusableButton>
          )}
        </div>
      </div>
    )
  }
}

PassportActivationScreen.propTypes = {
  userEmail: PropTypes.string,
  userValidPassport: PropTypes.bool,
  videoDetailsUrl: PropTypes.string,
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string,
      state: PropTypes.shape({
        navigatingFromDonation: PropTypes.bool,
        customDonationType: PropTypes.bool,
        stationTitle: PropTypes.string,
        fromSettings: PropTypes.bool,
        fromVideoDetails: PropTypes.bool,
      }),
    }),
    navigate: PropTypes.func,
  }),
  deviceUID: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    userEmail: state.user.email,
    userValidPassport: state.user.validPassport,
    videoDetailsUrl: state.content.id,
    deviceUID: state.device.UID,
  }
}

export default connect(
  mapStateToProps,
  null,
  null
)(withRouter(focusable(PassportActivationScreen)))
